import React from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown } from 'react-bootstrap';
import SideNav from '../components/SideNav';
import StepProgress from '../components/StepProgress';
import NotificationSettings from '../components/NotificationSettings';

function Settings({ 
  onEnableNotifications, 
  notificationToken, 
  isNotificationSupported 
}) {
    const projectSteps = [
        'Project Initiation',
        'Planning',
        'Execution',
        'Monitoring',
        'Closure'
      ];
      const currentStep = 3;
    return (
        <Container fluid className='p-3' style={{ backgroundColor: "#1a59ab", height: "100vh", }}>
            <Row>
                <Col className='col-auto'>
                   <SideNav />
                </Col>
                <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
                    <Row className='p-2' style={{ backgroundColor: "#154889", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                        <Col><h4 style={{ color: "white" }}>Project Dashboard</h4></Col>
                        <Col className="d-flex justify-content-end align-items-center">
                            <Image src={require('../assets/bell (1).png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px' }} />
                            <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                        </Col>
                    </Row>
                    <Row className='p-2 mt-2' style={{ backgroundColor: "#154889", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                        <Col><h5 style={{ color: "white" }}>Project Name</h5></Col>
                        <Col className='p-0'>
                            
                       <StepProgress
        steps={projectSteps}
        currentStep={currentStep}
        completedColor="#dc2626"    // Red for completed steps
        inProgressColor="#fbbf24"   // Yellow for the current step
        incompleteColor="#e5e7eb"   // Light gray for incomplete steps
      />
                        </Col>
                        <Col className="d-flex justify-content-end align-items-center"><Button style={{ backgroundColor: "#e85b13", borderColor: '#e85b13' }}>Change Stage</Button></Col>

                    </Row>
                    <Row>
                        <Col>
                              <NotificationSettings
            onEnableNotifications={onEnableNotifications}
            notificationToken={notificationToken}
            isNotificationSupported={isNotificationSupported}
          />
                        </Col>
                    </Row>

                </Col>
            </Row>
        </Container>
    )
}

export default Settings